import ButtonCustom from '../../atoms/button/ButtonCustom'
import styles from '../onboarding.module.css'

export const VendorType = ({
	userDetails,
	setUserDetails,
	setRole,
	setStep,
}) => {
	return (
		<div className={styles.roleSelect}>
			<div className={styles.roleButtons}>
				<ButtonCustom
					variant="pilled"
					data-cy="vendor-venue-onboarding"
					onClick={() => {
						setUserDetails({
							...userDetails,
							type: 'venue',
						})
						setStep((step) => step + 1)
					}}
				>
					Venue
				</ButtonCustom>
				<ButtonCustom
					variant="pilled"
					data-cy="vendor-vendor-onboarding"
					onClick={() => {
						setUserDetails({
							...userDetails,
							type: 'vendor',
						})
						setStep((step) => step + 1)
					}}
				>
					Vendors
				</ButtonCustom>
			</div>
			<button
				data-cy="backButton"
				onClick={() => setRole('')}
				className="backButton"
				style={{ margin: '40px auto 0 auto' }}
			>
				Back
			</button>
		</div>
	)
}
